import './style/ForgotPassword.css';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import PublicNav from '../components/PublicNav';
import { supabase } from '../supabaseClient';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [emailTouched, setEmailTouched] = useState(false);
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState('');
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const validateEmail = (value, touched = false) => {
        if (value.length === 0) return touched ? 'Required' : '';
        if (!emailRegex.test(value)) return 'Enter a valid email';
        return '';
    };

    const handleEmailChange = (e) => {
        const val = e.target.value;
        setEmail(val);
        if (emailTouched) setEmailError(validateEmail(val, true));
    };

    const handleEmailBlur = () => {
        setEmailTouched(true);
        setEmailError(validateEmail(email, true));
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setEmailTouched(true);
        const emErr = validateEmail(email, true);
        setEmailError(emErr);
        if (emErr) return;
        setLoading(true);
        setError('');
        try {
            const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
                redirectTo: `${window.location.origin}/reset-password`,
            });
            if (resetError) {
                setError(resetError.message);
                return;
            }
            setSent(true);
        } catch (err) {
            console.error(err);
            setError('Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='forgot-password-container'>
            <PublicNav />
            {sent ? (
                <div className='forgot-success'>
                    <div className='panel-header'>
                        <h3>Check Your Email</h3>
                        <p>We sent a password reset link to <strong>{email}</strong></p>
                    </div>
                    <p className='success-detail'>Click the link in the email to reset your password.</p>
                    <Link to="/login" className='back-to-login'>Back to Login</Link>
                </div>
            ) : (
                <form onSubmit={onSubmit}>
                    <div className='panel-header'>
                        <h3>Forgot Password</h3>
                        <p>Enter your email to receive a reset link</p>
                    </div>
                    <div className='credentials-section'>
                        <div className={`input-group${emailError && emailTouched ? ' input-error' : ''}`}>
                            <input className='email-input' type='text' name='email' id='forgot-email' value={email} onChange={handleEmailChange} onBlur={handleEmailBlur} placeholder=' '/>
                            <label htmlFor='forgot-email'>Email</label>
                            {emailError && emailTouched && <span className='field-error'>{emailError}</span>}
                        </div>
                        {error && <div className='error'>{error}</div>}
                    </div>
                    <div className='actions-section'>
                        <button type="submit" disabled={loading}>
                            {loading ? <div className='forgot-spinner' /> : 'Send Reset Link'}
                        </button>
                        <Link to="/login" className='back-link'>Back to Login</Link>
                    </div>
                </form>
            )}
        </div>
    );
};

export default ForgotPassword;
